import { apolloClient } from '../apolloClient'
import { CONFIRM_VISITATION_TO_CONSTRUCTION } from './mutations/CONFIRM_VISITATION_TO_CONSTRUCTION'
import { showErrorSnackbar } from '../../components/snackbar/Snackbar'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { setGlobal } from 'reactn'

export const confirmVisitationToConstruction = async (eventId: string) => {
  try {
    const response = await apolloClient.mutate({
      mutation: CONFIRM_VISITATION_TO_CONSTRUCTION,
      variables: { id: eventId },
    })

    await setGlobal({
      shouldRefreshRaffles: true,
    })
  } catch (e) {
    console.log('Error - Could not confirm presence to visitation. Reason: ', e)
    showErrorSnackbar(formatMessage(messages.appointments_couldNotConfirmPresence))
  }
}
